import { useController } from 'react-hook-form';
import { SegmentedControl, SegmentedControlProps } from 'ui/segmentedControl';
import { useMemo } from 'react';
import { FieldProps } from './types';

export type SelectControlFieldProps = FieldProps & { type?: SegmentedControlValueType } & Omit<
    SegmentedControlProps,
    'onSelect' | 'value'
  >;

export enum SegmentedControlValueType {
  String = 'string',
  Number = 'number',
}

export const SegmentedControlField = ({
  options,
  name,
  type = SegmentedControlValueType.String,
}: SelectControlFieldProps) => {
  const {
    field: { onChange, value },
  } = useController({
    name,
  });
  const handleChange = (val: string) => {
    if (type === SegmentedControlValueType.Number) {
      onChange(+val);
    } else {
      onChange(val);
    }
  };
  const currentValue = useMemo(
    () => (type === SegmentedControlValueType.Number ? value.toLocaleString() : value),
    [value],
  );
  return <SegmentedControl onSelect={handleChange} options={options} value={currentValue} />;
};
